import React from 'react';

import { useAppDispatch, useAppSelector } from '@/store';
import { clearRecommendedCampaigns, sessionFetchRecommendedCampaigns, sessionSetRecommendedCampaign } from '@/store/slices/session';

export function useRecommendedCampaigns(countryCode?: string) {
  const dispatch = useAppDispatch();
  const sessionId = useAppSelector((state) => state.session.sessionId);
  const sessionLoaded = useAppSelector((state) => state.session.loaded);
  const campaigns = useAppSelector((state) => state.session.recommendedCampaigns);
  const loading = useAppSelector((state) => state.session.loading);

  const fetchedRef = React.useRef(false);
  const prevCountryCodeRef = React.useRef(countryCode);

  React.useEffect(() => {
    if (prevCountryCodeRef.current === countryCode) return;
    prevCountryCodeRef.current = countryCode;
    fetchedRef.current = false;
    dispatch(clearRecommendedCampaigns());
  }, [countryCode, dispatch]);

  React.useEffect(() => {
    if (fetchedRef.current) return;
    if (!sessionLoaded || !sessionId) return;
    if (campaigns.length > 0) return;
    fetchedRef.current = true;
    dispatch(sessionFetchRecommendedCampaigns({ id: sessionId }));
  }, [dispatch, sessionLoaded, sessionId, campaigns.length]);

  const setCampaign = React.useCallback(
    (campaignId: string) => {
      if (!sessionId) return;
      return dispatch(sessionSetRecommendedCampaign({ id: sessionId, campaignId }));
    },
    [dispatch, sessionId],
  );

  return { campaigns, loading, setCampaign };
}
